<div class="row animate__animated animate__fadeIn" *ngIf="!loading">

  <!-- Slides -->
  <div class="col-12 mt-5 mt-lg-5 px-0 animate__animated animate__fadeIn animate__delay-1s"
    *ngIf="moviesSlideshow.length">
    <app-ui-slideshow [movies]="moviesSlideshow"></app-ui-slideshow>
  </div>

  <!-- Estrenos -->
  <div class="col-12 mt-5 mt-lg-5 px-0  animate__animated animate__fadeIn animate__delay-2s"
    *ngIf="moviesPremieres?.movies.length > 0">
    <app-ui-slides-carousel [title]="moviesPremieres.category.name" [movies]="moviesPremieres.movies">
    </app-ui-slides-carousel>
  </div>

  <!-- Movies en grilla agrupadas por categoría -->
  <div class="col-12 mt-5 mt-lg-5 px-0  animate__animated animate__fadeIn animate__delay-2s contenedorPeliculas"
    *ngIf="PARAMS?.HOME_LAYOUT.value == _ENUM_HOME_LAYOUT.Grouped">

    <div *ngFor="let category of moviesPerCategories">

      <app-ui-movies-grid *ngIf="!category.category.isCarrusel" [movies]="category.movies"
        [title]="category.category.name">
      </app-ui-movies-grid>

      <app-ui-slides-carousel *ngIf="category.category.isCarrusel" [movies]="category.movies"
        [title]="category.category.name" [showInfo]="true">
      </app-ui-slides-carousel>

    </div>

  </div>

  <br>

  <!-- loading de scroll -->
  <div class="loadingScroll" *ngIf="scrollLoading == true">
    <img class="animate__animated animate__flash animate__infinite animate__slow "
      src="assets\img\logos_cinemateca\SVG\logo_completo_blanco.svg" alt="Cinemateca" />
  </div>



  <!-- DESTAQUE DE MOVIE -->
  <div class="col-12  animate__animated animate__fadeIn animate__delay-6s" style="z-index: -1;">
    <app-filmic-file [filmicFile]="filmicFile"></app-filmic-file>
  </div>
</div>

<div class="loading_general">
  <img class="animate__animated animate__flash animate__infinite animate__slow "
    src="assets\img\logos_cinemateca\SVG\logo_completo_blanco.svg" alt="Cinemateca" />
</div>

<br />